export const isLocal = () =>
  ['bs-local.com:4000', 'localhost:4000'].includes(window.location.host);

export const isStage = () =>
  ['dash-stage.homefi.info'].includes(window.location.host);

export const isProd = () => ['dash.homefi.info'].includes(window.location.host);
